import { ISelectItem } from '@lla-platform/core/core-ui'
import { sortBy } from 'lodash'

export enum Permission {
  Reviews = 'Reviews',
  Receivables = 'Receivables',
  Invoices = 'Invoices',
  Contacts = 'Contacts',
  Calls = 'Calls',
  Reports = 'Reports',
  Inventories = 'Inventories',
  Admin = 'Admin',
  PackageGp = 'PackageGp',
  Tracker = 'Tracker',
  LostSales = 'LostSales',
  LostTiresReport = 'LostTiresReport',
  Tires = 'Tires',
  WorkOrders = 'WorkOrders',
  ObjectiveComps = 'ObjectiveComps',
  ManagePromotions = 'ManagePromotions',
  Attendance = 'Attendance',
  EmployeeManagement = 'EmployeeManagement',
  ScheduleShopManager = 'ScheduleShopManager',
  ScheduleRegionalManager = 'ScheduleRegionalManager',
  ManagePublicResources = 'ManagePublicResources',
  TiresManagement = 'TiresManagement',
  BCap = 'BCap',
  YearlyTargets = 'YearlyTargets',
  AdjGP = 'AdjGP',
  AdjGPExpert = 'AdjGPExpert',
  UpsellReport = 'UpsellReport',
  CallIntelligence = 'CallIntelligence',
  StatusBoardEditor = 'StatusBoardEditor',
  CallIntelligenceDrilldown = 'CallIntelligenceDrilldown',
  PreferredVendors = 'PreferredVendors',
  StatusBoardCommentsViewer = 'StatusBoardCommentsViewer',
  AnnouncementSenders = 'AnnouncementSenders',
  EventsCalendarRM = 'EventsCalendarRM',
  EventsCalendarDM = 'EventsCalendarDM',
  EventsCalendarAdmin = 'EventsCalendarAdmin'
}

export const EventsCalendarPermissions = [
  Permission.EventsCalendarRM,
  Permission.EventsCalendarDM,
  Permission.EventsCalendarAdmin
]

export function hasEventsCalendarAccess(permissions: Permission[] | null | undefined): boolean {
  return EventsCalendarPermissions.some((permission) => permissions?.includes(permission))
}

export const PermissionToLabel: { [key: string]: string } = {
  Reviews: 'Reviews',
  Receivables: 'Receivables',
  Invoices: 'Invoices',
  Contacts: 'Contacts',
  Calls: 'Calls',
  Reports: 'Reports',
  Inventories: 'Inventories',
  Admin: 'Admin',
  PackageGp: 'Package Gp',
  Tracker: 'Tracker',
  LostSales: 'Lost Sales',
  LostTiresReport: 'Lost Tires Report',
  Tires: 'Tires',
  WorkOrders: 'Work Orders',
  ObjectiveComps: 'Objective Comps',
  ManagePromotions: 'Manage Promotions',
  Attendance: 'Attendance',
  EmployeeManagement: 'Employee Management',
  ScheduleShopManager: 'Schedule Shop Manager',
  ScheduleRegionalManager: 'Schedule Regional Manager',
  ManagePublicResources: 'Manage Public Resources',
  TiresManagement: 'Tires Management',
  BCap: 'BCap',
  YearlyTargets: 'Yearly Targets',
  AdjGP: 'Adj GP',
  AdjGPExpert: 'Adj GP Expert',
  UpsellReport: 'Upsell Report',
  CallIntelligence: 'Call Intelligence',
  StatusBoardEditor: 'Status Board Editor',
  CallIntelligenceDrilldown: 'Call Intelligence Drilldown',
  PreferredVendors: 'Preferred Vendors',
  StatusBoardCommentsViewer: 'Status Board Comments Viewer',
  AnnouncementSenders: 'Send Announcements',
  EventsCalendarRM: 'Events Calendar RM',
  EventsCalendarDM: 'Events Calendar DM',
  EventsCalendarAdmin: 'Events Calendar Admin'
}

export const PermissionItems: ISelectItem[] = sortBy(
  [
    {
      label: PermissionToLabel[Permission.Reviews],
      value: Permission.Reviews
    },
    {
      label: PermissionToLabel[Permission.Receivables],
      value: Permission.Receivables
    },
    {
      label: PermissionToLabel[Permission.Invoices],
      value: Permission.Invoices
    },
    {
      label: PermissionToLabel[Permission.Contacts],
      value: Permission.Contacts
    },
    {
      label: PermissionToLabel[Permission.Calls],
      value: Permission.Calls
    },
    {
      label: PermissionToLabel[Permission.Reports],
      value: Permission.Reports
    },
    {
      label: PermissionToLabel[Permission.Inventories],
      value: Permission.Inventories
    },
    {
      label: PermissionToLabel[Permission.Admin],
      value: Permission.Admin
    },
    {
      label: PermissionToLabel[Permission.PackageGp],
      value: Permission.PackageGp
    },
    {
      label: PermissionToLabel[Permission.Tracker],
      value: Permission.Tracker
    },
    {
      label: PermissionToLabel[Permission.LostSales],
      value: Permission.LostSales
    },
    {
      label: PermissionToLabel[Permission.LostTiresReport],
      value: Permission.LostTiresReport
    },
    {
      label: PermissionToLabel[Permission.Tires],
      value: Permission.Tires
    },
    {
      label: PermissionToLabel[Permission.WorkOrders],
      value: Permission.WorkOrders
    },
    {
      label: PermissionToLabel[Permission.ObjectiveComps],
      value: Permission.ObjectiveComps
    },
    {
      label: PermissionToLabel[Permission.ManagePromotions],
      value: Permission.ManagePromotions
    },
    {
      label: PermissionToLabel[Permission.Attendance],
      value: Permission.Attendance
    },
    {
      label: PermissionToLabel[Permission.EmployeeManagement],
      value: Permission.EmployeeManagement
    },
    {
      label: PermissionToLabel[Permission.ScheduleShopManager],
      value: Permission.ScheduleShopManager
    },
    {
      label: PermissionToLabel[Permission.ScheduleRegionalManager],
      value: Permission.ScheduleRegionalManager
    },
    {
      label: PermissionToLabel[Permission.ManagePublicResources],
      value: Permission.ManagePublicResources
    },
    {
      label: PermissionToLabel[Permission.TiresManagement],
      value: Permission.TiresManagement
    },
    {
      label: PermissionToLabel[Permission.BCap],
      value: Permission.BCap
    },
    {
      label: PermissionToLabel[Permission.YearlyTargets],
      value: Permission.YearlyTargets
    },
    {
      label: PermissionToLabel[Permission.AdjGP],
      value: Permission.AdjGP
    },
    {
      label: PermissionToLabel[Permission.AdjGPExpert],
      value: Permission.AdjGPExpert
    },
    {
      label: PermissionToLabel[Permission.UpsellReport],
      value: Permission.UpsellReport
    },
    {
      label: PermissionToLabel[Permission.CallIntelligence],
      value: Permission.CallIntelligence
    },
    {
      label: PermissionToLabel[Permission.StatusBoardEditor],
      value: Permission.StatusBoardEditor
    },
    {
      label: PermissionToLabel[Permission.StatusBoardCommentsViewer],
      value: Permission.StatusBoardCommentsViewer
    },
    {
      label: PermissionToLabel[Permission.CallIntelligenceDrilldown],
      value: Permission.CallIntelligenceDrilldown
    },
    {
      label: PermissionToLabel[Permission.PreferredVendors],
      value: Permission.PreferredVendors
    },
    {
      label: PermissionToLabel[Permission.AnnouncementSenders],
      value: Permission.AnnouncementSenders
    },
    {
      label: PermissionToLabel[Permission.EventsCalendarRM],
      value: Permission.EventsCalendarRM
    },
    {
      label: PermissionToLabel[Permission.EventsCalendarDM],
      value: Permission.EventsCalendarDM
    },
    {
      label: PermissionToLabel[Permission.EventsCalendarAdmin],
      value: Permission.EventsCalendarAdmin
    }
  ],
  (x) => x.label
)

export const WherePermissionUsed: { [key: string]: string[] } = {
  Reviews: ['Page: Reviews'],
  Receivables: [
    'Page: Receivables - Locations',
    'Page: Receivables - Accounts',
    'Page: Receivables - AR Sales',
    'Page: Receivables - Receivables MA',
    'Page: Receivables - AR Payments',
    'Dashboard Receivables Widget',
    'Dashboard AR Receivables Widget'
  ],
  Invoices: [
    'Page: Invoices - Week To Date',
    'Page: Invoices - By Customer Type',
    'Page: Invoices - By Gross Profit',
    'Page: Invoices - By Deferred Type',
    'Page: Invoices - Categories MA',
    'Viewing Invoice Info on Contact Detail page',
    'Dashboard Invoices by Customer Type Widget'
  ],
  Contacts: [
    'Page: Contacts - List',
    'Page: Contacts - Phone/Email Overview',
    'Link from Invoices list to Contact Detail page'
  ],
  Calls: ['Viewing Call form on Contact Detail page / Disabled'],
  Reports: [
    'Page: LLA Objectives - Objectives MA',
    'Page: Reports - Sales',
    'Page: Reports - Fluids',
    'Page: Reports - Oil Change'
  ],
  Inventories: [],
  Admin: [
    'Page: Admin - Set Location Targets',
    'Page: Admin - Set Margins For Categories',
    'Page: Admin - Users',
    'Page: Admin - Locations',
    'Page: Admin - Surveys'
  ],
  PackageGp: [
    'Page: Packages GP - By Location',
    'Page: Packages GP - By Category',
    'Page: Packages GP - By Performance'
  ],
  Tracker: ['Page: Trackers'],
  LostSales: ['Page: Lost Sales Tire Tracker'],
  LostTiresReport: ['Page: Reports - Lost Tires'],
  Tires: [
    'Page: Tires - By Programs',
    'Page: Tires - By Levels',
    'Page: Tires - By Stockable',
    'Page: Tires - By Rotation',
    'Page: Tires - By Payment',
    'Dashboard Tires Widget'
  ],
  WorkOrders: ['Page: Work Orders'],
  ObjectiveComps: ['Page: LLA Objectives - Objectives vs Comp'],
  ManagePromotions: ['Page: Manage Promotions'],
  Attendance: ['Page: Attendance'],
  EmployeeManagement: ['Page: Employees - Employees List'],
  ScheduleShopManager: [
    'Page: Schedule',
    'Page: Attendance vs. Schedule',
    'Approve & Send for Regional Approval on Schedule page'
  ],
  ScheduleRegionalManager: [
    'Page: Schedule',
    'Page: Attendance vs. Schedule',
    'Approve Schedule On Schedule page',
    'Send Back for Revision on Schedule page',
    'Cancel Regional Approval on Schedule page'
  ],
  ManagePublicResources: ['Edit Employee Resources'],
  TiresManagement: [
    'Page: Tires - Stockable Items',
    'Page: Tires - Weekly Tire Report',
    'Viewing Update tire info modal on Tire List page'
  ],
  BCap: ['Page: BCap'],
  YearlyTargets: ['Page: LLA Objectives - Yearly targets'],
  AdjGP: ['Page: Reports - AdjGP Dashboard'],
  AdjGPExpert: ['Show Breakdown button on AdjGP report', 'Forecast info on AdjGP report'],
  UpsellReport: ['Page: Reports - Upsell Report'],
  CallIntelligence: ['Page: Call Intelligence'],
  StatusBoardEditor: ['Edit status & comments on Location Status Board'],
  CallIntelligenceDrilldown: ['Page: Call Intelligence Drilldown'],
  PreferredVendors: ['Page: Vendors - Preferred Vendors'],
  StatusBoardCommentsViewer: ['View comments on Location Status Board'],
  AnnouncementSenders: ['Send announcement button on Announcements page'],
  EventsCalendarRM: ['Page: Events Calendar', 'Access own calendar'],
  EventsCalendarDM: [
    'Page: Events Calendar',
    'Access own calendar and the calendars of Events Calendar RM users sharing a location'
  ],
  EventsCalendarAdmin: [
    'Page: Events Calendar',
    'Access own calendar and the calendars of Events Calendar DM and RM users sharing a location'
  ]
}
